var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJerrycan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5993 16.7524L20.0554 19.2085C19.9707 19.3779 19.886 19.6319 19.8013 19.886C19.8013 19.9707 19.8013 19.9707 19.7166 20.0554C19.6319 20.2248 19.6319 20.4788 19.5472 20.6482C19.5472 20.7329 19.5472 20.8176 19.5472 20.9023C19.5472 21.1564 19.4625 21.4104 19.4625 21.7492V48.1726C19.4625 50.798 21.5798 53 24.2899 53H50.6287C53.2541 53 55.456 50.8827 55.456 48.1726V6.16612C55.456 4.30293 53.9316 2.69381 51.9837 2.69381H35.9772C34.5375 2.69381 33.1824 3.7101 32.8436 5.06515L31.7427 11.2476C31.7427 11.4169 31.658 11.5016 31.5733 11.671C31.3192 12.0098 30.8958 12.2638 30.4723 12.2638H28.8632C28.0163 12.2638 27.1694 12.5179 26.4072 12.8567L24.0358 10.4853L23.0195 11.5016L17.7687 7.09772C15.7362 5.40391 13.2801 4.04886 10.6547 3.37134L2.43974 1L1 4.38762L8.87622 7.85993C10.8241 8.70684 12.5179 9.89251 14.0423 11.4169L18.5309 15.9055L17.5993 16.7524Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5603 9.97811V8.70775C51.5603 7.52208 50.9674 6.59048 49.7818 6.59048H37.7557C37.7557 6.59048 36.5701 6.50579 36.316 8.2843L35.9772 9.97811C35.9772 9.97811 35.5538 12.2648 37.8404 12.2648H49.7818C51.7297 12.2648 51.5603 9.97811 51.5603 9.97811Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5312 15.8219L23.0199 11.418",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3936 18.9539L26.4066 12.7715",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8402 41.1442C37.6708 41.1442 37.5862 41.1442 37.4168 41.1442C34.1985 40.9748 31.5731 38.3494 31.4037 35.1312C31.3191 33.9455 31.5731 32.7598 32.0813 31.7435L36.3158 23.6132C36.5699 23.0204 37.1627 22.6816 37.8402 22.6816C38.4331 22.6816 39.0259 23.0204 39.3647 23.6132L43.6839 31.8282C44.1073 32.6751 44.3614 33.6914 44.3614 34.623C44.3614 36.4015 43.5992 38.0953 42.3288 39.3657C41.0585 40.5513 39.4493 41.1442 37.8402 41.1442Z",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJerrycan);
export default __webpack_public_path__ + "static/media/Jerrycan.31796ff2fc14c16ccec683ae5288f556.svg";
export { ForwardRef as ReactComponent };